import { useDispatch } from 'react-redux'
import { AppDispatch } from 'store/main'

export const useAppDispatch: () => AppDispatch = useDispatch
